export default __webpack_public_path__ + "static/media/teachustheinsides.c5662970.png";